import {useState} from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import {DocumentOnList} from '..';


export const DocumentsList = ({
  canRemove,
  documents = [],
  label,
  listId,
  // these two are necessary if canRemove
  controlUuid,
  onRemoveDocument,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="documents__list-wrapper">
      <button
        aria-controls={listId}
        aria-expanded={isOpen}
        className="col-12 btn save-btn documents__list-button"
        onClick={() => setIsOpen(prevState => !prevState)}
        type="button"
      >
        {label}
        <span className="sr-only"> Kliknij, aby rozwinąć listę plików</span>
        <ArrowDownwardIcon aria-hidden="true" className={`documents__btn-icon${isOpen ? ' documents__btn-icon--colapse' : ''}`} />
      </button>
      <div className="row" id={listId}>
        {isOpen ?
          documents.length
            ? (
              <div className="col-12">
                <span role="alert" className="sr-only">Liczba plików: {documents.length} na liście {label}.</span>
                {documents.map(document => {
                  if (!document.file?.id) { return null }
                  return <DocumentOnList
                      canRemove={canRemove}
                      controlUuid={controlUuid}
                      key={document.id}
                      document={document}
                      onRemoveDocument={onRemoveDocument}
                  />
                })}
              </div>
              ) : <span className="col-12 info-text" role="alert">Brak plików<span
                  className="sr-only"> na liście: {label}</span></span>
            : null
        }
      </div>
    </div>
  )
};
